import React, { useEffect, useRef } from "react";
import "./HoppersRestaurantMenu.scss"
import MenuLayout from "../../components/MenuLayout/MenuLayout";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";


const HoppersRestaurantMenu = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "restaurantMenu")
    const Components = page?.Components || []
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);


    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantMenu-Hero-header":
                return <div className="HoppersRestaurantMenu-Hero-header">
                    {component?.Props?.text}
                </div>
            case "HoppersRestaurantMenu-Hero-subheader":
                return <div className="HoppersRestaurantMenu-Hero-subheader">
                    {component?.Props?.text1}<br />
                    {component?.Props?.text2}
                </div>
            case "HoppersRestaurantMenu-Hero-cont":
                return <div className="HoppersRestaurantMenu-Hero-cont">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="HoppersRestaurantMenu-Hero"
                style={{
                    backgroundImage: `linear-gradient(#00000099,#00000099), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getMenuComponent = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantMenu-Container-header":
                return <div className="HoppersRestaurantMenu-Container-header">
                    {component?.Props?.text}
                </div>
            case "HoppersRestaurantMenu-Container-subheader":
                return <div className="HoppersRestaurantMenu-Container-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersRestaurantMenu-Container-grid":
                return <div className="HoppersRestaurantMenu-Container-grid">
                    {component?.Data.map((data, key) => {
                        return (
                            <MenuLayout
                                key={key}
                                data={data}
                                isMenu />
                        )
                    })}
                </div>
            case "HoppersRestaurantMenu-Container-btn":
                return <div className="HoppersRestaurantMenu-Container-btn">
                    <Button
                        text={component?.Props?.btnText}
                        width={"max-content"}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getMenuContent = (components) => {
        return (
            <div className="HoppersRestaurantMenu-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getMenuComponent(component)
                    )
                })}
            </div>
        )
    }
    const getBookComponent = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantMenu-bottom-header":
                return <div className="HoppersRestaurantMenu-bottom-header">
                    {component?.Props?.text}
                </div>
            case "HoppersRestaurantMenu-bottom-subheader":
                return <div className="HoppersRestaurantMenu-bottom-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersRestaurantMenu-bottom-btn":
                return <div className="HoppersRestaurantMenu-bottom-btn">
                    <Button
                        text={component?.Props?.btnText}
                        width={component?.Props?.width}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getBookContent = (components, bottomBackground) => {
        return (
            <div className="HoppersRestaurantMenu-bottom"
                style={{
                    backgroundImage: `linear-gradient(#000000B2,#000000B2), url(${bottomBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (<div key={key}>
                        {getBookComponent(component)}
                    </div>)
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="HoppersRestaurantMenu-ImageCarousel" ref={containerRef}>
                <div className="HoppersRestaurantMenu-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="HoppersRestaurantMenu-Cont-image" />
                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantMenu-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "HoppersRestaurantMenu-Container":
                return getMenuContent(component.Components)
            case "HoppersRestaurantMenu-bottom":
                return getBookContent(component.Components, component?.Props?.bgSrc)
            case "HoppersRestaurantMenu-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersRestaurantMenu">

            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div >
    )
}
export default HoppersRestaurantMenu